import React from "react";

function DTOKPIPerfomance() {
  return <></>;
}

export default DTOKPIPerfomance;
